import React, { useCallback } from 'react';

import Hubspot from 'main/common/Hubspot';
import { Period, Plan } from 'pages/Landings/sections/Pricing/types';
import { useUserInfo } from 'queries/user-action/use-user-info';

import PlanSummary from '../Summary';

interface Props {
    period: Period;
    className?: string;
}

const ProPlanSummary: React.FC<Props> = ({ period, className }) => {
    const { data: user } = useUserInfo();
    const isAnnual = period === Period.ANNUALLY;

    const onClick = useCallback(() => {
        if (user) {
            Hubspot.send(Hubspot.PRICING_CLICK, { email: user.email });
        }
    }, [user]);

    return (
        <PlanSummary
            name="Pro"
            price={
                isAnnual
                    ? { primary: '$1075', secondary: 'per month', minor: '$12 900 annually' }
                    : { primary: '$1300', secondary: 'per month' }
            }
            button={{
                text: 'Request invoice',
                to: `/checkout?license=${Plan.PRO}&annual=${isAnnual}`,
                onClick
            }}
            className={className}
        />
    );
};

export default ProPlanSummary;
